export const GET_WISHLIST_REQ="GET_WISHLIST_REQ"
export const GET_WISHLIST_SUCCESS="GET_WISHLIST__SUCCESS"
export const GET_WISHLIST_FAIL="GET_WISHLIST_FAIL"



export const ADDTOWISHLIST_REQ="ADDTOWISHLIST_REQ"
export const ADDTOWISHLIS_SUCCESS="ADDTOWISHLIST__SUCCESS"
export const ADDTOWISHLIST_FAIL="ADDTOWISHLIST_FAIL"


export const  REMOVEFROMWISHLIST_REQ="REMOVEFROMWISHLIS_REQ"
export const  REMOVEFROMWISHLIST_SUCCESS="REMOVEFROMWISHLIS_SUCCESS"
export const  REMOVEFROMWISHLIST_FAIL="REMOVEFROMWISHLIS_FAIL"


export const  UPDATE_WISHLIST_REQ="UPDATE_WISHLIS_REQ"
export const  UPDATE_WISHLIST_SUCCESS="UPDATE_WISHLIS_SUCCESS"
export const  UPDATE_WISHLIST_FAIL="UPDATE_WISHLIS_FAIL"